/* ============================================================================
   atc-fallback.js — Filet de securite « Ajout au panier » (Jourdan / Eurus)
   ----------------------------------------------------------------------------
   N'agit QUE si Alpine.js n'a pas demarre (window.Alpine absent). Un seul
   ecouteur delegue en capture : si un declencheur d'ajout est clique et qu'Alpine
   est mort, on soumet nativement le <form action="/cart/add"> ou on renvoie vers
   la fiche produit. En navigateur sain, il ne fait STRICTEMENT rien.
   (Diagnostic ?atcdebug=1 retire le 05/06 apres usage.)
   ========================================================================== */
(function () {
  'use strict';

  var TRIGGER = 'button[name="add"], button[type="submit"], [data-add-to-cart], .add_to_cart_button, .js-choose-option, [data-action="choose-option"]';
  var FORM = 'form[action$="/cart/add"], form[data-type="add-to-cart-form"]';
  var CARD = '.card-product, .product-card, [data-product-url], li, .grid__item, .swiper-slide';
  function mark() { try { sessionStorage.setItem('atc_fallback_used', '1'); } catch (e) {} }

  document.addEventListener('click', function (ev) {
    if (window.Alpine) return; // Alpine OK -> chemin nominal
    var trigger = ev.target && ev.target.closest && ev.target.closest(TRIGGER);
    if (!trigger) return;
    try {
      var form = trigger.closest(FORM);
      if (form) {
        ev.preventDefault(); ev.stopImmediatePropagation(); mark();
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
        return;
      }
      var card = trigger.closest(CARD);
      var linkEl = card && card.querySelector && card.querySelector('a[href*="/products/"]');
      var href = (card && card.getAttribute && card.getAttribute('data-product-url')) || (linkEl && linkEl.getAttribute('href'));
      if (href) { ev.preventDefault(); ev.stopImmediatePropagation(); mark(); window.location.href = href; }
    } catch (e) { /* ne jamais casser la page */ }
  }, true);
})();
